module.exports = require('react/lib/ReactPerf');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-addons-perf/index.js
 ** module id = 120
 ** module chunks = 0
 **/